/**
 * Grid composite component exports
 *
 * Exports the Grid component (with the Grid.Item compound component),
 * variant helpers, and placement math utilities for use throughout the
 * application and by downstream grid-driven authoring UIs.
 */
export {
  Grid,
  type GridProps,
  GridItem,
  type GridItemProps,
  GridContext,
  type GridContextValue,
} from './Grid';
export {
  gridVariants,
  gridGapClass,
  GRID_GAP_CLASSES,
  GRID_MAX_CVA_COLUMNS,
  type GridVariantProps,
  type GridGap,
} from './grid.variants';
export {
  normalizeGridColumnCount,
  parseGridSpan,
  resolveColumnSpan,
  GRID_MIN_COLUMNS,
  GRID_MAX_COLUMNS,
  GRID_DEFAULT_COLUMNS,
  type GridSpan,
} from './grid-placement';
